import axios from '@axios';

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchUsers(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/user-management', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        createUser(ctx, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/user-management', payload)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        fetchUser(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/user-management/${id}/edit`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        updateUser(ctx, { id, payload }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/user-management/${id}`, payload)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        toggleStatus(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/user-management/${id}/toggle-status`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        resendCredentials(ctx, { id }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/user-management/${id}/resend-credentials`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        }
    }
}
